import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "AddConfigurationModal",
  tabindex: "-1",
  role: "dialog",
  ref: "addConfigurationModalRef",
  "aria-labelledby": "AddConfigurationModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "AddConfigurationModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12 mb-3" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-12 mb-3" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "form-check form-switch" }
const _hoisted_13 = {
  class: "form-check-label ms-2",
  for: "valeurSwitch"
}
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = {
  class: "btn btn-primary w-100",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString($setup.title), 1),
          _cache[1] || (_cache[1] = _createElementVNode("button", {
            class: "btn-close py-0",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Form, {
            ref: "configurationForm",
            onSubmit: $setup.addConfiguration,
            "validation-schema": $setup.configurationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Clé "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "cle",
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer la clé de configuration",
                      disabled: $setup.isUPDATE
                    }, null, 8, ["disabled"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "cle",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Valeur "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        role: "switch",
                        id: "valeurSwitch",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.currentValeur) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, $setup.currentValeur]
                      ]),
                      _createElementVNode("label", _hoisted_13, _toDisplayString($setup.valeurLabel), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", _hoisted_15, _toDisplayString($setup.btntext), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 512))
}